import { ICatalogLocale, ICatalogNavGroup, ICatalogNavGroupTreeItem } from '@pressreader/catalog-types';

import { ICatalogGroupDto, ICatalogLocaleDto } from './types';

const getIso = (groupDto: ICatalogGroupDto) => (groupDto.iso ? groupDto.iso.toLowerCase() : groupDto.iso);

function mapCatalogGroup(groupDto: ICatalogGroupDto): ICatalogNavGroup {
    const { categories: childCategories, ...tmp } = groupDto;
    const categories = childCategories ? childCategories.map(mapCatalogGroup) : [];
    return {
        ...tmp,
        items: categories,
        iso: getIso(groupDto),
    };
}

function mapCatalogGroupWithParent(groupDto: ICatalogGroupDto, parentNavGroupItemId: number): ICatalogNavGroup {
    const result = mapCatalogGroup(groupDto);
    result.parentNavGroupItemId = parentNavGroupItemId;
    return result;
}

function mapCatalogLocale(dto: ICatalogLocaleDto | null | undefined): ICatalogLocale[] | null {
    if (!dto) {
        return null;
    }
    return dto.locales
        .map(locale => {
            const [countryId, languageId] = locale;
            const country = dto.countries.find(c => c.id === countryId);
            const language = dto.languages.find(l => l.id === languageId);
            if (!country || !language) {
                return null;
            }
            return {
                code: `${language.iso}-${country.iso}`,
                country,
                language,
            };
        })
        .filter((locale): locale is ICatalogLocale => locale !== null);
}

function mapCatalogGroupTreeItem(groupDto: ICatalogGroupDto, parentId?: number): ICatalogNavGroupTreeItem {
    const { categories: childCategories, ...tmp } = groupDto;
    const categories = childCategories ? childCategories.map(c => mapCatalogGroupTreeItem(c, groupDto.id)) : [];
    return {
        ...tmp,
        items: categories,
        iso: getIso(groupDto),
        parentId,
    };
}

export { mapCatalogGroup, mapCatalogGroupTreeItem, mapCatalogGroupWithParent, mapCatalogLocale };
